import { TimelineGroup, TimelineItem } from '.';

export default class BatchLoader {
  private data: (TimelineGroup | TimelineItem)[] = [];
  private batchSize: number;
  private currentBatch: any = [];
  private startIndex: number;
  private endOfIndex: number;
  private endOfDataTop: boolean;
  private endOfDataBottom: boolean;

  constructor(data: (TimelineGroup | TimelineItem)[], batchSize: number) {
    this.data = data;
    this.batchSize = batchSize;
    this.startIndex = 0;
    this.endOfIndex = this.data.length + 1;
    this.endOfDataTop = false;
    this.endOfDataBottom = false;
    this.currentBatch = this.data.slice(this.startIndex, this.startIndex + this.batchSize);
  }

  getCurrentBatch(): any {
    return this.currentBatch;
  }

  getEndOfData() {
    return { top: this.endOfDataTop, bottom: this.endOfDataBottom };
  }

  loadMoreData(direction: 'up' | 'down') {
    if (this.data.length === 0) {
      this.endOfDataTop = true;
      this.endOfDataBottom = true;
      this.currentBatch = [];
      return;
    }

    if (direction === 'down') {
      const nextIndex = this.startIndex + this.batchSize;

      if (nextIndex >= this.endOfIndex) {
        this.endOfDataBottom = true;
        return; // Stop loading if at the end
      }

      this.endOfDataBottom = false; // Reset bottom
      this.endOfDataTop = false; // Reset top
      this.startIndex = Math.min(nextIndex, this.endOfIndex - this.batchSize);
    } else if (direction === 'up') {
      const prevIndex = this.startIndex - this.batchSize;

      if (prevIndex <= 0 && this.startIndex <= 0) {
        this.endOfDataTop = true;
        return; // Stop loading if at the start
      }

      this.endOfDataBottom = false; // Reset bottom
      this.endOfDataTop = false; // Reset top
      this.startIndex = Math.max(prevIndex, 0);
    }
    this.currentBatch = this.data.slice(this.startIndex, this.startIndex + this.batchSize);
  }
}
